import { render, staticRenderFns } from "./DREsideBar.vue?vue&type=template&id=ad09303a"
import script from "./DREsideBar.vue?vue&type=script&lang=js"
export * from "./DREsideBar.vue?vue&type=script&lang=js"
import style0 from "./DREsideBar.vue?vue&type=style&index=0&id=ad09303a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports